import React from 'react';
import Filter from '../../../../../Asset/images/icon/Filters-lines.svg';
import FilterModal from '../../../../../component/FilterModal';
import ImportExportIcon from '@mui/icons-material/ImportExport';

const FilterSection = ({
	category,
	sortby,
	handleFilterChange,
	handleOpenFilterModal,
	isFilterModalOpen,
	tags,
	selectedTags,
	selectedDurations,
	selectedLevels,
	selectedInstructors,
	handleTagChange,
	handleApplyFilter,
	handleResetFilter,
	handleCloseFilterModal,
	instructors,
	products,
	selectedProducts
}) => {
	return (
		<div className="c-tab_cata-text">
			<div id="c-mobile_tab_hide" className=" c-tab_cata mb-n9">
				<div className="row m-0 c-tab_box">
					<div className="col p-0">
						<div className="c-filter_btn c-filter_btn-lessons">
							<div className="c-filter_btn-one c-filter_btn-tags unique">
								<button type="button" onClick={handleOpenFilterModal} className="c-filters-btn">
									<img src={Filter} alt="" />
									Filters
								</button>
								{isFilterModalOpen && (
									<FilterModal
										isOpen={isFilterModalOpen}
										tags={tags}
										checkedTags={selectedTags}
										handleTagChange={handleTagChange}
										checkedDuration={selectedDurations}
										checkedInstructors={selectedInstructors}
										checkedLevels={selectedLevels}
										handleApplyFilter={handleApplyFilter}
										handleResetFilter={handleResetFilter}
										handleClose={handleCloseFilterModal}
										instructors={instructors}
										products={products}
										checkedProducts={selectedProducts}
									/>
								)}
							</div>
							<div className="c-filter_btn-one">
								<ImportExportIcon size={24} />
								<span>Sort by</span>
								<select className="filterby" onChange={handleFilterChange} value={sortby}>
									<option value={'latest'}>Newest</option>
									<option value={'oldest'}>Oldest</option>
									<option value={'title_asc'}>Title (A - Z)</option>
									<option value={'title_desc'}>Title (Z - A)</option>
									<option value={'long_duration'}>Longest</option>
									<option value={'short_duration'}>Shortest</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<h1>{category?.name}</h1>
		</div>
	);
};

export default FilterSection;
